module.exports = __webpack_public_path__ + "media/site_templates/www.furnituremovingservices.com.au/images/our_services_2-7e9f3d3d589498b82bcfd1747229153c.jpg";